import React from 'react';

import { Footer, Header } from '$partials/global';
import Util from '$utilities';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */


/**
 * @type {import('$types/components/pages.d.ts').ErrorPage}
 */
const ErrorPage = (props) => {
    const status = Util.try(() => props?.err?.statusCode) || 500;

    let message = '';

    switch(status) {
        case 404:
            message = '404 - Page not found.';
            break;

        default:
            message = 'Sorry, something went wrong.';
    }

    return (
        <>
            <Header {...props.data.header} />

            <main id='main-content'>
                <section className='theme-light-alt bg-main-background'>
                    <div className='layout-container layout-site-outer-padding py-24 sm:py-48 md:pt-160 md:pb-48'>
                        <div className='max-w-3xl'>
                            <h1 className='text-main-text-primary type-style-1'>
                                {message}
                            </h1>
                        </div>
                    </div>
                </section>
            </main>

            <Footer {...props.data.footer} />
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ErrorPage;
